module.exports = __webpack_public_path__ + "img/bancobpm-logo-no-bg.e56a4ca2.png";